import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getKpayment () {
    return new Promise((resolve, reject) => {
      HTTP.get('payment/kpayment').then(response => {
        if (response.status === 200) {
          resolve(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })
  },
  updateKpayment (params) {
    return new Promise((resolve, reject) => {
      HTTP.put('payment/kpayment', params).then(response => {
        if (response.status === 201) {
          resolve(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/kpayment/index.js